/**
 * Agent Pages -- Analytics
 *
 * Wraps the OverviewTab scoped to the current chatbot.
 */

import React from 'react'
import { useAgentContext } from '../../../components/layout/AgentContextLayout'
import { OverviewTab } from '../AgentHubTabs/OverviewTab'

export const AgentAnalyticsPage: React.FC = () => {
  const { chatbot } = useAgentContext()

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold tracking-tight text-foreground">Analytics</h1>
      <OverviewTab chatbot={chatbot} />
    </div>
  )
}
